const NAMESPACE = 'current-user/';

export default {
  SET_ID: `${NAMESPACE}SET_ID`,
};
